import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { AISummary, AISummaryStatus } from "@/shared/domain/ai_summary";

export function useFileSummary(
  fileId: string,
  options?: {
    pendingPollRateMs?: number;
  },
): UseQueryResult<AISummary, Error> {
  const { files } = useDomainServices();

  return useQuery<AISummary, Error>({
    queryKey: ["file-summary", fileId],
    queryFn: ({ signal }) => {
      return files.getSummary(fileId, {
        abortSignal: signal,
      });
    },
    staleTime: 300 * 1000, // Cache this for 5 minutes, since it's expensive to compute
    refetchInterval: (query) => {
      const data = query.state.data;
      const pendingPollRateMs = options?.pendingPollRateMs ?? 2000; // Explicit polling rate or 2 seconds
      return data?.status === AISummaryStatus.Pending
        ? pendingPollRateMs
        : false;
    },
  });
}
